import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';

/**
 * Shows template HTML only inside a sandboxed iframe (no scripts, no same-origin),
 * never in the page DOM. srcdoc is set on the element directly so Angular's
 * sanitizer does not strip the email's styles.
 */
@Component({
    selector: 'app-template-preview',
    templateUrl: './template-preview.component.html',
    styleUrls: ['./template-preview.component.scss'],
})
export class TemplatePreviewComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

    @Input() heading = 'Preview';
    @Input() subject = '';
    @Input() html = '';
    @Input() note = '';
    @Output() closed = new EventEmitter<void>();

    /** Width to show the email at; 'mobile' is a 375px phone screen. */
    device: 'desktop' | 'mobile' = 'desktop';

    @ViewChild('frame') private frame: ElementRef<HTMLIFrameElement>;
    @ViewChild('closeButton', { read: ElementRef }) private closeButton: ElementRef<HTMLButtonElement>;

    constructor(private _host: ElementRef<HTMLElement>) { }

    ngOnInit(): void {
        // Inside the page content the sidebar is drawn on top of any fixed overlay and covered the
        // preview's left edge. Like a Material dialog, show it from <body> so it covers the whole screen.
        document.body.appendChild(this._host.nativeElement);
    }

    ngOnDestroy(): void {
        this._host.nativeElement.remove();
    }

    ngAfterViewInit(): void {
        this.render();
        // Keyboard users start on the close button, so Enter/Escape both get them out.
        setTimeout(() => this.closeButton?.nativeElement.focus());
    }

    @HostListener('document:keydown.escape')
    onEscape(): void {
        this.closed.emit();
    }

    ngOnChanges(): void {
        this.render();
    }

    private render(): void {
        if (this.frame) {
            this.frame.nativeElement.srcdoc = this.html || '';
        }
    }
}
